import React, { useMemo } from "react";

import { Box, Typography } from "@mui/material";
import { postfixes } from "root/utils";
import { socialNetworksData } from "root/utils/socialNetworks";

import { instagramDisclaimer } from "root/js/utils";

// --------------------------------------------------------------------
const SocialNetworksChartTooltipContent = ({ data, disabled }) => {
  const source = useMemo(
    () => socialNetworksData.find(i => i.name === data.item)?.title || data.item,
    [data]
  );
  const countString = useMemo(
    () => data.item && data.count && `${source} - ${data.count}${postfixes.pcs}`,
    [data]
  );
  return (
    <Box>
      {!!data.count && (
        <Typography
          variant="subtitle2"
          fontSize={12}
          sx={{ color: !disabled ? "#cf3aa0" : "grey" }}>
          {!disabled
            ? "нажмите на иконку, чтобы открыть " + (data.count > 1 ? "список постов" : "пост")
            : 'просмотр постов доступен только на тарифах "Профессиональный" и "Корпоративный"'}
        </Typography>
      )}
      <Typography variant="h6">{countString}</Typography>
      {data.item === "instagram" && (
        <Typography variant="subtitle2" fontSize={10}>
          {instagramDisclaimer}
        </Typography>
      )}
    </Box>
  );
};

export default SocialNetworksChartTooltipContent;
